import { render, staticRenderFns } from "./BigWheel.vue?vue&type=template&id=3e691a70"
import script from "./BigWheel.vue?vue&type=script&lang=js"
export * from "./BigWheel.vue?vue&type=script&lang=js"
import style0 from "./BigWheel.styles.scss?vue&type=style&index=0&prod&lang=scss&less=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_9104b087796de0a589f26e8ae34b49bc/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports